import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Dimmer, Modal, Loader, Menu, Icon, Header, Button, Grid } from "semantic-ui-react";
import { HotTable} from "@handsontable/react";
import Handsontable from "handsontable";
import "handsontable/dist/handsontable.full.css";
import * as clientActions from "../../actions/clients/getClientActions";
import { createNotification, NOTIFICATION_TYPE_SUCCESS } from 'react-redux-notify';
import { colHeaders } from "./taxTobeLinkedColHeader";
import { colWidths } from "./taxToBeLinkedcolWidth";
import {taxToBeLinkedPage} from './taxToBeLinkedStyle';
import {filterEnabledCols} from './taxToBeLinkedFilterEnableCols';
import {controlsheet} from "../../Constants/API";

try {
    var userDetails = atob(localStorage.getItem("userDetails"));
    if (userDetails) {
            userDetails = JSON.parse(userDetails);
        }
    } 
catch (e) {
    window.location.reload();
}

var FIRM_ID = null;
FIRM_ID = userDetails.UserContext.firmId;

class TaxTaskToBeLinkedPageActions extends Component {
    constructor(props) {
        super(props);
        this.settings = {
            licenseKey: "0b014-a057a-62a00-d4631-40c07",
            className: "htLeft",
            fillHandle: {
                direction: "vertical",
                autoInsertRow: false
            },
            columnSorting: true,
            multiColumnSorting: false,
            manualColumnResize: true,
            manualRowResize: true,
            filters: filterEnabledCols,
            dropdownMenu: ["filter_action_bar", "filter_by_value"],
            observeDOMVisibility: true,
            observeChanges: true,
            stretchH: "all",
            headerTooltips: {
                rows: false,
                columns: true,
                onlyTrimmed: false
            },
            hiddenColumns: {
                  columns: [0],
                  indicators: false
            }
           
        };
        this.columns = [
                { 
                    data: 'taskId',
                    type: 'text',
                    readOnly: true
                },
                {
                    data: 'clientFullName',
                    renderer: clientnameRender.bind(this),
                    type: 'text',
                    readOnly: true 
                },
                { 
                    data: 'accountNumber',
                    type: 'text',
                    readOnly: true,
                    renderer: gridRowRenderer.bind(this)
                },
                { 
                    data: 'taskDesc',
                    type: 'text',
                    readOnly: true ,
                    renderer: gridRowRenderer.bind(this)
                },
                { 
                    data: 'taskType',
                    type: 'text',
                    readOnly: true,
                    renderer: gridRowRenderer.bind(this)
                },
                { 
                    data : 'periodEndDate',
                    type: 'text',
                    readOnly: true,
                    renderer: gridRowRenderer.bind(this)
                },
                { 
                    data : 'statusName',
                    type: 'text',
                    readOnly: true,
                    renderer: gridRowRenderer.bind(this)
                },
                { 
                    data : 'dueDate',
                    type: 'text', 
                    readOnly: true,
                    renderer: gridRowRenderer.bind(this)
                }
          ]
    }

    showLoader() {
        return (
            <Dimmer page active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>
        );
    }

    componentDidMount() {
        this.props.clientActions.getTaxTaskToBeLinkedData(FIRM_ID).then((res)=>{
             
        });  
        document.body.style.overflow = "hidden";
    }

    render(){
        return (
            <Fragment>
                 {(this.props.allTaxToBelinkedData.length != 0  && !this.props.allTaxToBelinkedData.length )
                    ? this.showLoader()
                    : ""}
                {(this.props.allTaxToBelinkedData.length!=0) ?
                    <div style={taxToBeLinkedPage}>
                        <HotTable
                            settings={this.settings}
                            colHeaders= {colHeaders}
                            colWidths={colWidths}
                            columns={this.columns}
                            data={this.props.allTaxToBelinkedData}
                            width="100%"
                            height="calc(100vh - 80px)"
                            id="hottable"
                        />
                    </div> : <div className=" ui message" id="norecord" style={{ background: "#efefef", lineHeight:"0.8em"}}>
                                <div className="header customHeader" style={{fontSize:"0.9em"}}>
                                    {" "}
                                    No Records Found.
                                </div>
                            </div>
                }
            </Fragment>
            );
        }
}

function clientnameRender(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.BaseRenderer.apply(this, arguments);
    if (prop === "clientFullName") {
        let rowData = cellProperties.instance.getSourceDataAtRow(
            cellProperties.instance.toPhysicalRow(row)
        );
        if (!rowData) {
            return;
        }
        td.style.fontSize='13px';
        let url = controlsheet + window.btoa(rowData.taskId);
        let controlsheetUrl ='<a href = javascript:window.open('+'"'+url+'"'+',"Routing","scrollbars=yes,type=fullWindow,fullscreen,resizable=yes,width='+document.documentElement.clientWidth+',height='+document.documentElement.clientWidth+'") style="cursor:pointer">'+ value + '</a>';
        td.innerHTML = controlsheetUrl;      
    }
}

function gridRowRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    td.style.fontSize='13px';
  }


const mapStateToProps = state => {
     return {
         allTaxToBelinkedData: state.clientReducer.requiredTaxToBeLinkedData
    };
};

const mapDispatchToProps = dispatch => ({
    clientActions: bindActionCreators(clientActions, dispatch),
    createNotification: (config) => {
        dispatch(createNotification(config))
    },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TaxTaskToBeLinkedPageActions);
